import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "../styles/linkbuilding_5.css";

handleFloatingPromise(initExpertSite());
